<template>
	<form class="form-generate-app"  @submit.prevent="generateApp">	
		<p class="title-form">DATOS DE NEGOCIO</p>
		<v-layout row wrap class="mb-3 wrapper-inputs">
			<v-flex xs12>
				<v-select
					class="input-component"
					label="Rubro"
					v-model="model.business"
					item-text="name"
					item-value="name"
					:items="activities"
					hide-details
					autocomplete
					single-line
				/>
			</v-flex>
			<v-flex xs12>
				<input 
					type="text"
					placeholder="Nombre de tu negocio"
					class="input-component"
					v-model="model.nameWarehouse">
			</v-flex>
			<v-flex xs12>
				<v-select
					class="input-component"
					:label="captionDepartament"
					v-model="model.department"
					item-text="name"
					item-value="name"
					:items="departaments"
					hide-details
					autocomplete
					single-line
				/>
			</v-flex>
			<v-flex xs12>
				<input 
					type="text"
					placeholder="Tu dirección"
					class="input-component"
					v-model="model.address"
				/>
			</v-flex>
			<v-flex xs12 md6 class="padding-responsive">
				<label for="color" class="caption">Escoge tu paleta de colores (5)</label>
				<v-select
					id="color"
					class="input-component"
					:disabled="loadingColor"
					label="Tus colores"
					v-model="model.color"
					item-text="value"
					item-value="id"
					:items="colors"
					hide-details
					single-line
					return-object
					@change="changeColor"
				>
					<template slot="selection" slot-scope="data">
						<v-layout>
							<v-flex xs12>
								<div class="wrapper-colors">
									<div 
										:style="`background-color: ${data.item.primary}`"
										class="color"></div>
									<div 
										:style="`background-color: ${data.item.secondary}`"
										class="color"></div>
									<div 
										:style="`background-color: ${data.item.tertiary}`"
										class="color"
									></div>
									<div 
										:style="`background-color: ${data.item.fourth}`"
										class="color border"
									></div>
									<div 
										:style="`background-color: ${data.item.fifth}`"
										class="color"
									></div>
								</div>
							</v-flex>
						</v-layout>
					</template>
					<template slot="item" slot-scope="data">
						<v-layout>
							<v-flex xs3 class="color-text">Paleta {{data.item.id}}</v-flex>
							<v-flex xs9 pl-1>
								<div class="wrapper-colors">
									<div 
										:style="`background-color: ${data.item.primary}`"
										class="color"></div>
									<div 
										:style="`background-color: ${data.item.secondary}`"
										class="color"></div>
									<div 
										:style="`background-color: ${data.item.tertiary}`"
										class="color"
									></div>
									<div 
										:style="`background-color: ${data.item.fourth}`"
										class="color border"
									></div>
									<div 
										:style="`background-color: ${data.item.fifth}`"
										class="color"
									></div>
								</div>
							</v-flex>
						</v-layout>
					</template>
				</v-select>
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap>
					<v-flex xs12 md6 class="padding-responsive">
						<v-layout wrap>
							<v-flex xs10 md9>
								<label for="logo" class="caption">Sube tu logo (si no tienes lo puedes subir más tarde)</label>
								<input
									placeholder="logo.jpg"
									class="input-component upload"
									id="logo"
									readonly
									v-model="model.logo">
							</v-flex>
							<v-flex xs2 md3 class="pt-21">
								<label ref="up" for="upload-image">
									<vue-six-four id="upload-image" hidden @vue-six-four="getFile($event, 'logo')" />
									<button 
										class="btn-upload" 
										@click="actionUploadImage('up')"
										type="button">
										<img 
											src="/static/images/banners/upload.svg" 
											alt="upload"
											height="18">
									</button>
								</label>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md6>
						<v-layout wrap>
							<v-flex xs10 md9>
								<label for="background" class="caption">Sube tu fondo (si no tienes lo puedes subir más tarde)</label>
								<input
									placeholder="fondo.jpg"
									class="input-component upload"
									id="background"
									readonly
									v-model="model.background">
							</v-flex>
							<v-flex xs2 md3 class="pt-21">
								<label ref="upBackground" for="upload-image-background">
									<vue-six-four id="upload-image-background" hidden @vue-six-four="getFile($event, 'background')" />
									<button 
										class="btn-upload" 
										@click="actionUploadImage('upBackground')"
										type="button"
									>
										<img 
											src="/static/images/banners/upload.svg" 
											alt="upload"
											height="18"
										/>
									</button>
								</label>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<p class="title-form">DATOS DE CONTACTO</p>
		<v-layout row wrap class="mb-3 wrapper-inputs">
			<v-flex xs12>
				<input 
					type="text"
					placeholder="Tu nombre"
					class="input-component"
					v-model="model.name">
			</v-flex>
			<v-flex xs12>
				<input 
					type="text"
					placeholder="Tus apellidos"
					class="input-component"
					v-model="model.surName">
			</v-flex>
			<v-flex xs12>
				<v-layout row wrap>
					<v-flex xs3>
						<v-select
							class="input-component left-radius"
							label="Tu país"
							v-model="model.country"
							item-text="value"
							item-value="name"
							:items="countries"
							hide-details
							single-line
						>
							<template slot="selection" slot-scope="data">
								<div>
									<img 
										:src="data.item.image" 
										:alt="data.item.name"
										height="20">
									<span>{{data.item.value}}</span>
								</div>
							</template>
							<template slot="item" slot-scope="data">
								<div>
									<img 
										:src="data.item.image" 
										:alt="data.item.name"
										height="20">
									<span>{{data.item.value}}</span>
								</div>
							</template>
						</v-select>
					</v-flex>
					<v-flex xs9>
						<input 
							type="number"
							placeholder="Tu celular"
							class="input-component right-radius"
							v-model="model.phone"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12>
				<input 
					type="email"
					placeholder="Tu correo electrónico"
					class="input-component"
					v-model="model.email">
			</v-flex>
			<v-flex xs12>
				<input 
					type="password"
					placeholder="Tu contraseña"
					class="input-component"
					v-model="model.password"
				/>
			</v-flex>
		</v-layout>
		<p class="title-form">COSTO DE IMPLEMENTACIÓN</p>
		<v-layout row wrap class="mb-3 wrapper-inputs">
			<v-flex xs12>
				<div class="layout wrap align-center justify-center coupon-container">
					<span class="coupon-label">Cupón de descuento:</span>
					<span class="coupon-value">{{ couponValue }}</span>
				</div>
				<div class="layout wrap align-center implementation-cost">
					<span class="implementation-cost-actual">
						{{ currencySymbol }} {{ costActual }}
					</span>
					<span class="implementation-cost-discount">
						{{ currencySymbol }} {{ costWithDiscount | round }}
					</span>
					<span class="implementation-cost-text">Incluye {{ taxLabel }}</span>
				</div>
				<div class="layout wrap align-center justify-center coupon-container">
					<span class="coupon-label">Pedicréditos de regalo:</span>
					<span class="coupon-value">{{ creditQuantity }} creditos gratis</span>
				</div>
			</v-flex>
		</v-layout>
		<v-layout row wrap align-center class="title-form">
			<v-flex xs6>
				<p class="ma-0">¿DESEAS FACTURA?</p>
			</v-flex>
			<v-flex xs6>
				<v-checkbox
					color="success"
					hide-details
					v-model="billingCheck"
				></v-checkbox>
			</v-flex>
		</v-layout>
		<v-layout v-if="billingCheck" row wrap class="wrapper-inputs">
			<v-flex xs12>
				<input 
					type="text"
					placeholder="RUC"
					class="input-component"
					v-model="model.ruc"
					@input="rucValidate"
				/>
			</v-flex>
		</v-layout>
		<v-layout class="wrapper-btn">
			<v-flex xs12>
				<button 
					class="btn-form"
					:disabled="disabledRegisterApp || disabledBtn"
					type="submit">ACTIVA TU APP</button>
			</v-flex>
		</v-layout>
	</form>
</template>
<script>
import VueSixFour from 'vue-six-four';
import helper from '@/shared/helper';
import selectColor from '@/components/generate-app/select-color';

const { debounce } = helper;

function created() {
	const items = process.env.ITEMS;
	this.activities = items.split(', ').map(i => ({ name: i }));
	this.model.country = this.isPeru ? 'Perú' : 'Ecuador';
	this.taxLabel = process.env.COUNTRY === 'PER' ? 'IGV' : 'IVA';
	this.currencySymbol = process.env.COUNTRY === 'PER' ? 'S/' : '$';
}

function changeColor(item) {
	this.loadingColor = true;
	this.$emit('change-color', item);
	setInterval(() => {
		this.loadingColor = false;
	}, 1000);
}

function actionUploadImage(identifier) {
	this.$refs[identifier].click();
}

async function getFile(fileInfo, modelProp) {
	const labelLoading = modelProp === 'logo' ? 'loadingLogo' : 'loadingBackground';
	const newFile = {
		name: fileInfo.name.replace(/\s/g, '-'),
		image: fileInfo.sixFour,
	};
	this[labelLoading] = true;
	try {
		const words = newFile.name.split('.');
		const lastItem = words.length;
		const extension = words[lastItem - 1];
		newFile.type = extension;
		if (this.allowedFiles.indexOf(extension) > -1) {
			const { data: response } = await this.$http.post('image/one-upload', newFile);
			this.model[modelProp] = response.data.url_image;
			this.$emit(
				`change-${modelProp}`,
				{ value: this.model[modelProp], loading: this[labelLoading] },
			);
		} else {
			this.showNotification(`Archivo no válido, solo se permite ${this.allowedFiles.join(',')}`, 'warning');
		}
	} catch (error) {
		if (error.data.statusCode === 413) {
			this.showGenericError('Tamaño máximo de imagen permitido es 1024Kb');
		} else {
			this.showGenericError();
		}
	}
}

async function generateApp() {
	const coupon = process.env.COUPON;
	const body = { ...this.model };
	if (!this.isPeru && body.phone.length === 10) {
		if (Number(body.phone[0]) === 0) {
			const phoneStr = body.phone.toString();
			body.phone = phoneStr.slice(1, 10);
		}
	}
	delete body.color.id;
	const prefix = this.countries.find(c => c.name === body.country);
	body.phone = `${prefix.phone}${body.phone}`;
	body.flagNotifications = true;
	body.dataNotifications = {
		codeNotificationClient: process.env.TEMPLATE_SUCCESS,
		codeNotificationCompany: process.env.TEMPLATE_CONFIGURACTION,
		companyId: process.env.COMPANY_ID_APP,
		sheetId: process.env.SHEET_ID_APP,
		emailCompany: process.env.FORM_TO_APP,
		from: process.env.FORM_FROM_APP,
		phoneCompany: process.env.PHONE_COMPANY,
		wtsTemplateCompany: process.env.WSP_APP_COM,
		wtsTemplateClient: process.env.WSP_APP_CLIENT,
	};
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	try {
		const response = await this.$http.post(`store-app/${coupon}`, body, { headers });
		if (Number(response.status) === 201) {
			this.goTo(
				'page-success-inscription',
				{
					params: {
						fullName: `${body.name} ${body.surName}`,
					},
				},
			);
		}
	} catch (err) {
		this.showGenericError('Ya expiró el tiempo o ya no es válido el token para la configuracion');
	}
}

function disabledBtn() {
	return (!this.model.business || !this.model.nameWarehouse ||
		!this.model.password || !this.model.name || !this.model.email ||
		!this.model.surName || !this.model.country || !this.model.phone) ||
		(this.billingCheck && !this.model.ruc) || (this.model.ruc && this.rucInvalid);
}

function captionDepartament() {
	return this.isPeru ? 'Departamento' : 'Pronvicia';
}

async function rucValidate({ target }) {
	const ruc = target.value;
	if (ruc) {
		const params = { codeCountry: process.env.COUNTRY };
		try {
			({ data: this.apiResponse } = await this.$httpApi.get(`ruc/${ruc}`, { params }));
			this.rucInvalid = false;
		} catch (err) {
			if (err.status === 405) {
				this.rucInvalid = true;
				this.showGenericError(err.data.message);
			}
		}
	} else {
		this.rucInvalid = true;
	}
}

function data() {
	return {
		activities: [],
		apiResponse: {},
		billingCheck: false,
		errorData: {},
		model: {
			address: '',
			business: null,
			nameWarehouse: null,
			password: null,
			logo: null,
			background: null,
			color: {
				fifth: '#000000',
				fourth: '#ffffff',
				id: 1,
				primary: '#02979b',
				secondary: '#b1dc03',
				tertiary: '#085f65',
			},
			name: null,
			email: null,
			surName: null,
			country: 'Perú',
			phone: null,
			ruc: null,
		},
		allowedFiles: ['jpg', 'png', 'jpeg'],
		colors: [
			{
				id: 1,
				primary: '#02979b',
				secondary: '#b1dc03',
				tertiary: '#085f65',
				fourth: '#ffffff',
				fifth: '#000000',
			},
			{
				id: 2,
				primary: '#014a99',
				secondary: '#ffec00',
				tertiary: '#003773',
				fourth: '#ffffff',
				fifth: '#000000',
			},
			{
				id: 3,
				primary: '#f01d1d',
				secondary: '#2266aa',
				tertiary: '#cb0000',
				fourth: '#ffffff',
				fifth: '#000000',
			},
			{
				id: 4,
				primary: '#00ab82',
				secondary: '#08b4cd',
				tertiary: '#268871',
				fourth: '#ffffff',
				fifth: '#000000',
			},
			{
				id: 5,
				primary: '#000000',
				secondary: '#ede200',
				tertiary: '#2d2d2d',
				fourth: '#ffffff',
				fifth: '#000000',
			},
		],
		countries: [
			{
				id: 1,
				value: '+51',
				name: 'Perú',
				image: '/static/images/banners/peru.svg',
				phone: '51',
			},
			{
				id: 2,
				value: '+593',
				name: 'Ecuador',
				image: '/static/images/banners/ecuador.svg',
				phone: '593',
			},
		],
		couponValue: process.env.COUPON,
		costActual: process.env.IMPLEMENTATION_REGULAR_PRICE,
		costWithDiscount: process.env.IMPLEMENTATION_DISCOUNT_PRICE,
		creditQuantity: process.env.CREDIT_QUANTITY,
		loadingBackground: false,
		loadingColor: false,
		loadingLogo: false,
		taxLabel: '',
		currencySymbol: '',
		rucInvalid: true,
	};
}
export default {
	name: 'form-generate-app',
	data,
	components: {
		selectColor,
		VueSixFour,
	},
	computed: {
		disabledBtn,
		captionDepartament,
	},
	created,
	methods: {
		changeColor,
		actionUploadImage,
		getFile,
		generateApp,
		rucValidate: debounce(rucValidate),
	},
	props: {
		disabledRegisterApp: {
			type: Boolean,
			default: false,
		},
		token: String,
		departaments: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.title-form {
		border-bottom: 2px solid color(back-green);
		color: color(title-green);
		font-family: font(lato-regular);
		font-weight: map-get($weight, w800);
		font-size: size(medium16);
		margin-bottom: 20px;
		padding-bottom: 6px;

		@media (max-width: 936px) {
			margin: 0 20px 20px 20px;
		}
	}

	.input-component {
		border: 1px solid color(input);
		border-radius: 8px;
		height: 40px;
		margin-bottom: 20px;
		padding: 0 15px;
		width: 100%;

		&:focus {
			outline: 0px;
		}

		&.upload {
			border-radius: 8px 0 0 8px;
		}

		&.left-radius {
			border-bottom-left-radius: 8px;
			border-bottom-right-radius: 0px;
			border-top-left-radius: 8px;
			border-top-right-radius: 0px;
		}

		&.right-radius {
			border-bottom-left-radius: 0px;
			border-bottom-right-radius: 8px;
			border-top-left-radius: 0px;
			border-top-right-radius: 8px;
		}

		@media (max-width: 936px) {
			border-radius: 3px;
			height: 50px;
		}
	}

	.btn-form {
		background: color(title-green);
		border-radius: 9px;
		color: color(white);
		font-family: font(lato-regular);
		font-size: size(medium16);
		font-weight: map-get($weight, w900);
		padding: 10px 35px;
	}

	.form-generate-app {
		background: color(white);
		border-radius: 8px;
		margin: 19px auto 0px;
		padding: 0px 45px 48px;
		max-width: 592px;
		overflow: hidden;

		@media (max-width: 936px) {
			box-shadow: none;
			padding: 0;
		}
	}

	.center {
		text-align: center;
	}

	.btn-upload {
		background-color: color(green-link);
		border-radius: 0 9px 9px 0;
		height: 40px;
		padding: 0 20px;

		@media (max-width: 936px) {
			height: 50px;
		}
	}

	.caption {
		color: color(caption);
		font-size: size(small);
	}

	.pt-21 {
		padding-top: 41px;
	}

	.color {
		border-radius: 50%;
		flex: 1 1 auto;
		max-width: 21px;
		height: 21px;
	}

	.wrapper-colors {
		display: flex;
		justify-content: space-around;
	}

	.color-text {
		font-size: size(small11);
	}

	.wrapper-btn {
		background-color: color(back-gray-b);
		bottom: 0;
		left: 0;
		padding: 25px 0;
		position: absolute;
		right: 0;
		text-align: center;
		width: 100%;

		@media (max-width: 936px) {
			position: relative;
		}
	}

	.wrapper-inputs {
		@media (max-width: 936px) {
			padding: 0 20px;
		}
	}

	.border {
		border: 1px solid color(border);
	}

	.padding-responsive {
		@media (min-width: 936px) {
			padding-right: 15px;
		}
	}

	.coupon-container {
		border: 1px solid color(green-dark);
		border-radius: 6px;
		height: 44px;
		margin-bottom: 16px;
		max-width: 365px;
		text-transform: uppercase;
	}

	.coupon-label {
		color: color(form-grey);
		font-family: font(lato-regular);
		font-size: size(small);
		font-weight: weight(w700);
	}

	.coupon-value {
		color: color(green-dark);
		font-family: font(lato-regular);
		font-size: size(medium15);
		font-weight: weight(w900);
		padding-left: 5px;
	}

	.implementation-cost {
		margin-bottom: 20px;

		&-actual {
			color: rgba(8, 95, 101, 0.58);
			font-family: font(lato-regular);
			font-size: size(medium23);
			font-weight: weight(w700);
			position: relative;

			&:before {
				background-color: rgba(8, 95, 101, 0.58);
				bottom: 15px;
				content: '';
				height: 3px;
				left: -3px;
				position: absolute;
				transform: rotate(-7deg);
				width: 110%;
			}
		}

		&-discount {
			color: color(green-dark);
			font-family: font(lato-regular);
			font-size: size(large28);
			font-weight: weight(w900);
			padding: 0px 28px; 
		}

		&-text {
			color: color(form-grey);
			font-family: font(lato-regular);
			font-size: size(small);
			font-weight: weight(w700);
			text-transform: uppercase;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/form-generate-app.vue